import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-down-left', 'ArrowDownLeft', [["path",{"d":"M17 7l-10 10"}],["path",{"d":"M16 17l-9 0l0 -9"}]]);